import "./contact.css";
import data from "../contact/data";
import ContactComponent from "../../component/ContactComponent";
const Contact = () => {
  return (
    <section id="contact">
      <div className="contact__all">
        <h2 className="contactName">Get In Touch</h2>
        <div className="contact-grid">
          {data.map((item, idx) => (
            <ContactComponent key={idx} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
